import React, { Fragment } from 'react';

import useCountdown from '@/features/gmv-target-banner/hooks/useCountdown';
import { formatInteger, padTwo } from '@/features/gmv-target-banner/utils/format';

// Kept in its own component so the per-second tick re-renders only the clock.
const Countdown = ({ deadline, timeZone }) => {
	const { days, hours, minutes, seconds, totalHours, totalMinutes } = useCountdown(deadline);

	const units = [
		{ label: 'Days', value: days },
		{ label: 'Hours', value: padTwo(hours) },
		{ label: 'Minutes', value: padTwo(minutes) },
		{ label: 'Seconds', value: padTwo(seconds) }
	];

	return (
		<div className="gmv-banner__countdown">
			<h2 className="gmv-banner__headline">Make every second count.</h2>
			<div className="gmv-banner__clock" role="timer" aria-live="off">
				{units.map((unit, index) => (
					<Fragment key={unit.label}>
						{index > 0 && (
							<span className="gmv-banner__clock-separator" aria-hidden="true">
								:
							</span>
						)}
						<div className="gmv-banner__clock-unit">
							<span className="gmv-banner__clock-value">{unit.value}</span>
							<span className="gmv-banner__clock-label">{unit.label}</span>
						</div>
					</Fragment>
				))}
			</div>
			<p className="gmv-banner__note">
				{formatInteger(totalHours)} hours · {formatInteger(totalMinutes)} minutes left
			</p>
			<p className="gmv-banner__note gmv-banner__note--muted">Until 31 December ends · {timeZone}</p>
		</div>
	);
};

export default Countdown;
